
import React from "react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Sparkles } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { getVariablesByCategory } from "@/utils/templateVariables";

interface VariablePickerProps {
  onSelectVariable: (variable: string) => void;
}

const VariablePicker: React.FC<VariablePickerProps> = ({ onSelectVariable }) => {
  const [open, setOpen] = React.useState(false);
  const templateVariablesByCategory = getVariablesByCategory();

  const handleVariableClick = (variableName: string) => {
    console.log("Variable clicked:", variableName);
    onSelectVariable(`{{ ${variableName} }}`);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="flex items-center gap-1">
          <Sparkles className="h-4 w-4" />
          <span>Insert Variable</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0" align="start">
        <div className="p-4 border-b">
          <h4 className="font-medium">Template Variables</h4>
          <p className="text-sm text-muted-foreground">
            Insert dynamic content into your template
          </p>
        </div>
        {/* Fixed height ScrollArea with visible scrollbar */}
        <ScrollArea className="h-[280px] overflow-auto" style={{ maxHeight: "280px" }}>
          <div className="p-2">
            {Object.entries(templateVariablesByCategory).map(([category, variables]) => (
              <div key={category} className="p-2">
                <h5 className="text-sm font-medium text-muted-foreground px-2 py-1">
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </h5>
                <div className="space-y-1">
                  {variables.map((variable) => (
                    <Button
                      key={variable.name}
                      variant="ghost"
                      className="w-full justify-start text-sm"
                      onClick={() => handleVariableClick(variable.name)}
                    >
                      <div className="flex flex-col items-start">
                        <span className="font-mono">{`{{ ${variable.name} }}`}</span>
                        <span className="text-xs text-muted-foreground">
                          {variable.description}
                        </span>
                      </div>
                    </Button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
};

export default VariablePicker;
